module.exports = __webpack_public_path__ + "img/pagerduty.ca4b5401.svg";